"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalSettings = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const Container_1 = __importDefault(require("@material-ui/core/Container"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const styles_1 = require("@material-ui/core/styles");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const form_1 = require("../../../composite/form/form");
const form_submit_button_1 = require("../../../composite/form/fields/form-submit-button");
const internal_settings_context_1 = require("./internal-settings-context");
const internal_settings_fields_1 = require("./internal-settings-fields");
const useStyles = styles_1.makeStyles({
    page: {
        height: '100%',
        overflowY: 'auto',
    },
    container: {
        marginTop: 15,
        justifyContent: 'center',
        width: '100%',
    },
    titleWrapper: {
        textAlign: 'left',
        borderBottom: '1px solid #cdcdcd',
    },
    title: {
        display: 'inline-block',
        margin: '10px 0',
        fontSize: 25,
        fontWeight: 500,
    },
});
function InternalSettings() {
    const classes = useStyles();
    const { loading, saveInternalSettings, settingGroups } = react_1.useContext(internal_settings_context_1.InternalSettingsContext);
    const formRef = react_1.useRef(null);
    const [editing, setEditing] = react_1.useState(false);
    const handleStartEditing = event_callback_hook_1.useEventCallback(() => {
        setEditing(true);
    });
    const handleCancelEditing = event_callback_hook_1.useEventCallback(() => {
        var _a;
        setEditing(false);
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.setFieldValue('settingGroups', settingGroups);
    });
    const handleSubmit = event_callback_hook_1.useEventCallback(async () => {
        if (formRef.current != undefined) {
            await saveInternalSettings(formRef.current.getFieldValues().settingGroups);
            setEditing(false);
        }
    });
    react_1.useEffect(() => {
        var _a;
        (_a = formRef === null || formRef === void 0 ? void 0 : formRef.current) === null || _a === void 0 ? void 0 : _a.setFieldValue('settingGroups', settingGroups);
    }, [settingGroups]);
    return (react_1.default.createElement("div", { className: classes.page },
        react_1.default.createElement(Container_1.default, { maxWidth: "lg" },
            react_1.default.createElement(Grid_1.default, { container: true, spacing: 5, className: classes.container },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement("div", { className: classes.titleWrapper },
                        react_1.default.createElement(Typography_1.default, { variant: "h1", className: classes.title },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTTINGS__TITLE", defaultMessage: "Nastaven\u00ED aplikace" })))),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(form_1.Form, { initialValues: {}, editing: !loading && editing, onSubmit: handleSubmit, ref: formRef },
                        react_1.default.createElement(internal_settings_fields_1.SettingsFields, null),
                        react_1.default.createElement(Buttons, { editing: editing, handleStartEditing: handleStartEditing, handleCancelEditing: handleCancelEditing, loading: loading })))))));
}
exports.InternalSettings = InternalSettings;
const Buttons = ({ loading, editing, handleCancelEditing, handleStartEditing, }) => (react_1.default.createElement(Grid_1.default, { container: true },
    react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 12 },
        react_1.default.createElement(Box_1.default, { height: 50 }),
        react_1.default.createElement(Box_1.default, { display: "flex", flexDirection: "row-reverse" },
            !editing && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", disabled: loading, onClick: handleStartEditing },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTINGS__BTN_EDIT", defaultMessage: "Upravit" })),
                react_1.default.createElement(Box_1.default, { width: 10 }))),
            editing && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Button_1.default, { variant: "contained", disabled: loading, onClick: handleCancelEditing },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTINGS__BTN_CANCEL", defaultMessage: "Zru\u0161it" })),
                react_1.default.createElement(Box_1.default, { width: 10 }))),
            editing && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(form_submit_button_1.FormSubmitButton, { variant: "contained", color: "primary", type: "submit", disabled: loading, startIcon: loading && react_1.default.createElement(CircularProgress_1.default, { size: "20px", color: "inherit" }) },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTINGS__BTN_SAVE", defaultMessage: "Ulo\u017Eit" })),
                react_1.default.createElement(Box_1.default, { width: 10 })))))));
//# sourceMappingURL=internal-settings.js.map